export default __webpack_public_path__ + "static/media/smsAlert.46adb74f.mp3";